import _defineProperty from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty";
import "vant/lib/toast/style";
import _Toast from "vant/lib/toast";
import "core-js/modules/es6.array.find";
import _Promise from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/core-js/promise";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator";

var _actions;

import * as types from "@/store/constants/types";
import { payByIap } from "@/api/pay/index";
import GeneralUtilsHelper from "@/utils/generalUtils";
import { sendMapEvent } from "@/utils/analytics";
import { erroToMsg } from "@/utils/errorToMsg";
import { i18n } from "@/i18n/i18n-setup";
import { isIos } from "@/utils/lodash";
var actions = (_actions = {}, _defineProperty(_actions, types.PAY_BY_IAP, function () {
  var _ref2 = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee2(_ref, payload) {
    var state, commit, dispatch;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            state = _ref.state, commit = _ref.commit, dispatch = _ref.dispatch;
            return _context2.abrupt("return", new _Promise(
            /*#__PURE__*/
            function () {
              var _ref3 = _asyncToGenerator(
              /*#__PURE__*/
              regeneratorRuntime.mark(function _callee(resolve, reject) {
                var offer_id, result;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        _context.prev = 0;
                        offer_id = payload.offer_id;
                        console.log("offer_id", offer_id);
                        _context.next = 5;
                        return payByIap(offer_id);

                      case 5:
                        result = _context.sent;
                        console.log("PAY_BY_IAP result: ", result);
                        resolve(result);
                        _context.next = 13;
                        break;

                      case 10:
                        _context.prev = 10;
                        _context.t0 = _context["catch"](0);
                        reject(_context.t0);

                      case 13:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee, null, [[0, 10]]);
              }));

              return function (_x3, _x4) {
                return _ref3.apply(this, arguments);
              };
            }()));

          case 2:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function (_x, _x2) {
    return _ref2.apply(this, arguments);
  };
}()), _defineProperty(_actions, types.INIT_IAP, function () {
  var _ref5 = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee4(_ref4, payload) {
    var state, commit, dispatch;
    return regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            state = _ref4.state, commit = _ref4.commit, dispatch = _ref4.dispatch;
            return _context4.abrupt("return", new _Promise(
            /*#__PURE__*/
            function () {
              var _ref6 = _asyncToGenerator(
              /*#__PURE__*/
              regeneratorRuntime.mark(function _callee3(resolve, reject) {
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                  while (1) {
                    switch (_context3.prev = _context3.next) {
                      case 0:
                        try {
                          Cordova.exec(function (res) {
                            console.log("INIT_IAP res:", res);
                            resolve(res);
                          }, function (error) {
                            console.log("INIT_IAP error:", error);
                            reject(error);
                          }, "InAppBillingV3", "init", []);
                        } catch (error) {
                          reject(error);
                        }

                      case 1:
                      case "end":
                        return _context3.stop();
                    }
                  }
                }, _callee3);
              }));

              return function (_x7, _x8) {
                return _ref6.apply(this, arguments);
              };
            }()));

          case 2:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function (_x5, _x6) {
    return _ref5.apply(this, arguments);
  };
}()), _defineProperty(_actions, types.REGISTER_PRODUCT_ID, function () {
  var _ref8 = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee6(_ref7, payload) {
    var state, commit, dispatch;
    return regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            state = _ref7.state, commit = _ref7.commit, dispatch = _ref7.dispatch;
            return _context6.abrupt("return", new _Promise(
            /*#__PURE__*/
            function () {
              var _ref9 = _asyncToGenerator(
              /*#__PURE__*/
              regeneratorRuntime.mark(function _callee5(resolve, reject) {
                var initTimes, registerProcess;
                return regeneratorRuntime.wrap(function _callee5$(_context5) {
                  while (1) {
                    switch (_context5.prev = _context5.next) {
                      case 0:
                        try {
                          initTimes = 0;

                          registerProcess = function registerProcess() {
                            initTimes += 1;
                            var productIdArray = GeneralUtilsHelper.getProductIdArray();

                            var retryRegister = function retryRegister(error) {
                              if (initTimes >= 3) {
                                reject(error);
                              } else {
                                //重试：
                                console.log("REGISTER_PRODUCT_ID 重试》》》");
                                registerProcess();
                              } //打点:


                              sendMapEvent("uia_register_product_id_failed", {
                                value: erroToMsg(error)
                              });
                            };

                            inAppPurchase.getProducts(productIdArray).then(function (products) {
                              console.log("REGISTER_PRODUCT_ID success:", products);

                              if (products.length === 0 || products.length !== productIdArray.length) {
                                retryRegister(new Error("register_product_id_length_not_match"));
                                return;
                              }

                              resolve(); //更新状态:

                              commit(types.UPDATE_INIT_IAP_STATUS, true);
                            }).catch(function (err) {
                              console.log("REGISTER_PRODUCT_ID err", err);
                              retryRegister(err);
                            });
                          };

                          registerProcess();
                        } catch (error) {
                          console.log("error", error);
                          reject(error);
                        }

                      case 1:
                      case "end":
                        return _context5.stop();
                    }
                  }
                }, _callee5);
              }));

              return function (_x11, _x12) {
                return _ref9.apply(this, arguments);
              };
            }()));

          case 2:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));

  return function (_x9, _x10) {
    return _ref8.apply(this, arguments);
  };
}()), _defineProperty(_actions, types.CHECK_INIT_IAP_STATUS, function () {
  var _ref11 = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee8(_ref10, payload) {
    var state, commit, dispatch, getters;
    return regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            state = _ref10.state, commit = _ref10.commit, dispatch = _ref10.dispatch, getters = _ref10.getters;
            return _context8.abrupt("return", new _Promise(
            /*#__PURE__*/
            function () {
              var _ref12 = _asyncToGenerator(
              /*#__PURE__*/
              regeneratorRuntime.mark(function _callee7(resolve, reject) {
                var status;
                return regeneratorRuntime.wrap(function _callee7$(_context7) {
                  while (1) {
                    switch (_context7.prev = _context7.next) {
                      case 0:
                        _context7.prev = 0;
                        console.log("CHECK_INIT_IAP_STATUS");

                        if (!isIos()) {
                          _context7.next = 14;
                          break;
                        }

                        status = getters[types.GETTER_INIT_IAP_STATUS];

                        if (!status) {
                          _context7.next = 8;
                          break;
                        }

                        resolve();
                        _context7.next = 12;
                        break;

                      case 8:
                        //重新init:
                        console.log("CHECK_INIT_IAP_STATUS register again");
                        _context7.next = 11;
                        return dispatch(types.REGISTER_PRODUCT_ID);

                      case 11:
                        resolve();

                      case 12:
                        _context7.next = 15;
                        break;

                      case 14:
                        //安卓不需要检测:
                        resolve();

                      case 15:
                        _context7.next = 20;
                        break;

                      case 17:
                        _context7.prev = 17;
                        _context7.t0 = _context7["catch"](0);
                        reject(_context7.t0);

                      case 20:
                      case "end":
                        return _context7.stop();
                    }
                  }
                }, _callee7, null, [[0, 17]]);
              }));

              return function (_x15, _x16) {
                return _ref12.apply(this, arguments);
              };
            }()));

          case 2:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));

  return function (_x13, _x14) {
    return _ref11.apply(this, arguments);
  };
}()), _defineProperty(_actions, types.PAY_VIP, function () {
  var _ref14 = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee10(_ref13, payload) {
    var state, commit, dispatch, getters;
    return regeneratorRuntime.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            state = _ref13.state, commit = _ref13.commit, dispatch = _ref13.dispatch, getters = _ref13.getters;
            return _context10.abrupt("return", new _Promise(
            /*#__PURE__*/
            function () {
              var _ref15 = _asyncToGenerator(
              /*#__PURE__*/
              regeneratorRuntime.mark(function _callee9(resolve, reject) {
                var vipOfferList, offer_id, isCanBuy, result;
                return regeneratorRuntime.wrap(function _callee9$(_context9) {
                  while (1) {
                    switch (_context9.prev = _context9.next) {
                      case 0:
                        _context9.prev = 0;
                        commit(types.UPDATE_LOADING_STATUS, true); //检测是否初始化:

                        _context9.next = 4;
                        return dispatch(types.CHECK_INIT_IAP_STATUS);

                      case 4:
                        vipOfferList = getters[types.GETTER_VIP_OFFER_LIST];
                        offer_id = payload ? payload : getters[types.GETTER_OFFER_ID]; //检测offer_id是否存在;

                        isCanBuy = false;

                        if (vipOfferList && vipOfferList.length > 0) {
                          isCanBuy = vipOfferList.find(function (item) {
                            return item === offer_id;
                          });
                        }

                        if (isCanBuy) {
                          _context9.next = 12;
                          break;
                        }

                        //如果不能买抛出错误
                        _Toast(i18n.t("toast.cant_find_product"));

                        commit(types.UPDATE_LOADING_STATUS, false);
                        return _context9.abrupt("return");

                      case 12:
                        _context9.next = 14;
                        return dispatch(types.PAY_BY_IAP, {
                          offer_id: offer_id
                        });

                      case 14:
                        result = _context9.sent;

                        if (!(result && result.data && result.data.service_info)) {
                          _context9.next = 21;
                          break;
                        }

                        _context9.next = 18;
                        return dispatch(types.UPDATE_SERVICE_LIST);

                      case 18:
                        resolve(true);
                        _context9.next = 22;
                        break;

                      case 21:
                        resolve(false);

                      case 22:
                        resolve(result);
                        commit(types.UPDATE_LOADING_STATUS, false);
                        _context9.next = 34;
                        break;

                      case 26:
                        _context9.prev = 26;
                        _context9.t0 = _context9["catch"](0);
                        console.log("PAY_VIP error", _context9.t0);
                        reject(_context9.t0);
                        commit(types.UPDATE_LOADING_STATUS, false);

                        if (!(_context9.t0 && _context9.t0.text && _context9.t0.text.indexOf("cancel") > -1 || _context9.t0 === "canceled")) {
                          _context9.next = 33;
                          break;
                        }

                        return _context9.abrupt("return");

                      case 33:
                        _Toast("".concat(i18n.t("common.toast.payment_failed")));

                      case 34:
                      case "end":
                        return _context9.stop();
                    }
                  }
                }, _callee9, null, [[0, 26]]);
              }));

              return function (_x19, _x20) {
                return _ref15.apply(this, arguments);
              };
            }()));

          case 2:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10);
  }));

  return function (_x17, _x18) {
    return _ref14.apply(this, arguments);
  };
}()), _actions);
export default actions;